<template>
  <div>
    <div class="container-fixed offset-bottom-1">
      <br />
      <!-- filters -->
      <section class="form-input-set barring-filters">
        <span id="filterSelection" class="label col-l-1 col-m-12 col-s-12">{{ $t('barring.filterSelection') }}:</span>
        <div v-if="!hideFilterType" class="btn-sectioned pull-left col-m-12 col-s-12" role="tablist" aria-labelledby="filterSelection">
          <VButton
            class="btn-default"
            label="barring.btnFilterAll"
            :active="!isFilterFactoring && !isFilterVoice"
            :selected="!isFilterFactoring && !isFilterVoice"
            role="tab"
            @click="onToggleFilterOff"
          />
          <VButton
            class="btn-default"
            label="barring.btnFilterFactoring"
            :active="isFilterFactoring"
            :selected="isFilterFactoring"
            role="tab"
            @click="onToggleFilterFactoring"
          />
          <VButton
            class="btn-default"
            label="barring.btnFilterVoice"
            :active="isFilterVoice"
            :selected="isFilterVoice"
            role="tab"
            @click="onToggleFilterVoice"
          />
        </div>
        <div class="btn-sectioned col-m-12 col-s-12" :class="{ 'pull-right': !hideFilterType }" role="tablist" aria-labelledby="filterSelection">
          <VButton
            class="btn-default"
            label="barring.btnFilterBarred"
            :active="isFilterBarred"
            :selected="isFilterBarred"
            :title="$t(appendType('barring.tooltipFilterBarred'))"
            role="tab"
            @click="onToggleFilterBarred"
          />
          <VButton
            class="btn-default"
            label="barring.btnFilterUnbarred"
            :active="isFilterUnbarred"
            :selected="isFilterUnbarred"
            :title="$t(appendType('barring.tooltipFilterUnbarred'))"
            role="tab"
            @click="onToggleFilterUnbarred"
          />
        </div>
      </section>
    </div>
    <div class="container-fixed offset-bottom-1">
      <br />
      <!-- filters -->
      <section class="form-input-set barring-filters">
        <label class="col-l-1 col-m-12 col-s-12" for="search">{{ $t('barring.filterSearch') }}:</label>
        <input
          id="search"
          v-model="search"
          type="text"
          class="form-input"
          name="search"
          :placeholder="$t('barring.filterPlaceholder_' + type)"
          :title="$t(appendType('barring.tooltipFilterInput'))"
        />
        <div class="col-s-12 col-m-12 pull-right btn-sectioned">
          <button class="btn btn-clean" :title="$t(appendType('barring.tooltipFilterReset'))" @click="onFilterReset">
            <VSvgIcon name="reload" variant="outlined" />
            {{ $t('barring.btnFilterReset') }}
          </button>
        </div>
      </section>
    </div>
    <div class="container-fluid grayed-offset">
      <div class="container-fixed">
        <br />
        <div>
          <section v-if="!readOnly" class="col-l-8 col-m-12 col-s-12 barring-actions offset-bottom-1">
            <div :key="filterKey" class="btn-text" role="status" aria-live="polite">
              <span v-if="isFilterOn">{{ $tc(appendType('barring.chosen'), filteredItems.length) }}</span>
              <span v-else>{{ $t(appendType('barring.all')) }}</span
              >:
            </div>
            <div class="btn-sectioned offset-right-1">
              <button type="button" class="btn btn-default" :title="$t(appendType('barring.tooltipBtnSelectionBar'))" @click="lockSelection">
                <img src="@/assets/images/barring/status-solid-lock.svg" alt="" aria-hidden="true" />
                {{ $t('barring.btnSelectionBar') }}
              </button>
              <button type="button" class="btn btn-default" :title="$t(appendType('barring.tooltipBtnSelectionUnbar'))" @click="unlockSelection">
                <img src="@/assets/images/barring/status-solid-unlock.svg" alt="" aria-hidden="true" />
                {{ $t('barring.btnSelectionUnbar') }}
              </button>
            </div>
          </section>
          <div class="col-l-4 col-m-12 barring-actions">
            <!-- aria-live element for reader always in the DOM -->
            <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">
              <span v-if="isNoticeVisible">
                <span v-if="mutableNotice.hasExceptions" v-html="noticeNameHasException" />
                <span v-else-if="mutableNotice.name" v-html="noticeNameWasStatus" />
                <span v-else v-html="noticeMultipleWereStatus" />
              </span>
            </div>
            <!-- visual notification DOM -->
            <transition name="fade" mode="out-in" appear>
              <div v-if="isNoticeVisible" :key="noticeKey" class="notification notification-warning">
                <span v-if="mutableNotice.hasExceptions" v-html="noticeNameHasException" />
                <span v-else-if="mutableNotice.name" v-html="noticeNameWasStatus" />
                <span v-else v-html="noticeMultipleWereStatus" />
                <button type="button" class="close" @click="onCloseNotice">
                  <VSvgIcon name="cancel" variant="outlined" />
                  <span class="sr-only">{{ $t('common.close') }}</span>
                </button>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid grayed-offset">
      <div class="container-fixed unmargin-top">
        <!-- list -->
        <VList :items="filteredItems" @toggle="onToggle" @open:exceptions="onOpenExceptions" v-on="$listeners">
          <div class="h-ctr offset-top-3 offset-bottom-4">
            <p>{{ $t('barring.noEntriesFound') }}</p>
            <button class="btn btn-default offset-bottom-1 h-ctr" :title="$t(appendType('barring.tooltipFilterReset'))" @click="onFilterReset">
              <VSvgIcon name="reload" variant="outlined" />
              {{ $t('barring.btnFilterReset') }}
            </button>
          </div>
        </VList>
      </div>
    </div>
  </div>
</template>

<script>
import VList from '@/components/Barring/PartnerSelection/List';
import VButton from '@/components/Button';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'BarringProfileEditForm',

  components: {
    VSvgIcon,
    VList,
    VButton,
  },

  provide() {
    return {
      getType: this.type,
      readOnly: this.readOnly,
    };
  },

  props: {
    items: {
      type: Array,
      required: true,
    },

    hideFilterType: {
      type: Boolean,
      reqired: false,
    },

    notice: {
      type: Object,
      required: false,
      default: null,
    },

    type: {
      type: String,
      required: true,
      validator(value) {
        return ['partners', 'categories', 'shortCode', 'voice-partner-exceptions', 'content-partner-exceptions', 'reselling'].includes(value);
      },
    },

    readOnly: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      search: '',
      isFilterFactoring: false,
      isFilterVoice: false,
      isFilterBarred: false,
      isFilterUnbarred: false,
      isNoticeVisible: false,
      noticeKey: 0,
      mutableNotice: this.notice,
    };
  },

  computed: {
    filteredItems() {
      return this.items.filter((item) => {
        if (this.isFilterBarred && !item.hasExceptions && !item.isBarred) return false;
        if (this.isFilterUnbarred && !item.hasExceptions && item.isBarred) return false;

        if (this.isFilterFactoring && item.type !== 'factoring') return false;
        if (this.isFilterVoice && !['voiceFactoring', 'globalShortCode'].includes(item.type)) return false;

        if (this.search.length === 0) return true;
        return (
          this.getTranslation(item.name).toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          item.items.some((subItems) => subItems.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
        );
      });
    },

    filterKey() {
      return !this.isFilterOn || this.filteredItems.length;
    },

    noticeItem() {
      return `${this.$t('barring.type_' + this.mutableNotice.type)} <b>${this.getTranslation(this.mutableNotice.name)}</b>`;
    },

    noticeNameHasException() {
      return this.$t('barring.noticeNameHasException', {
        name: this.noticeItem,
      });
    },

    noticeNameWasStatus() {
      return this.$t('barring.noticeNameWasStatus', {
        name: this.noticeItem,
        status: this.$t(`barring.noticeStatus${this.mutableNotice.isBarred ? 'Barred' : 'Unbarred'}`),
      });
    },

    noticeMultipleWereStatus() {
      return this.$t('barring.noticeMultipleWereStatus', {
        name: this.$t('barring.typePlural_' + this.type),
        status: this.$t(`barring.noticeStatus${this.mutableNotice.isBarred ? 'Barred' : 'Unbarred'}`),
      });
    },

    isFilterOn() {
      return this.isFilterFactoring || this.isFilterVoice || this.isFilterBarred || this.isFilterUnbarred || this.search.length > 0;
    },
  },

  watch: {
    mutableNotice: 'updateNoticeKey',
    notice: 'updateNotice',
  },

  created() {
    if (this.notice) {
      this.updateNotice();
    }
  },

  methods: {
    getTranslation(name) {
      return this.$tm('barring.contentTypeCode_', name);
    },

    updateNoticeKey() {
      this.noticeKey = this.noticeKey + 1;
      this.isNoticeVisible = true;

      this.$emit('notice', this.mutableNotice);
    },

    updateNotice() {
      this.mutableNotice = Object.assign({}, this.notice);
    },

    appendType(base) {
      return `${base}_${this.type}`;
    },

    onFilterReset() {
      this.search = '';
      this.isFilterFactoring = false;
      this.isFilterVoice = false;
      this.isFilterBarred = false;
      this.isFilterUnbarred = false;
    },

    onToggleFilterOff() {
      this.isFilterVoice = false;
      this.isFilterFactoring = false;
    },

    onToggleFilterFactoring() {
      this.isFilterVoice = false;
      this.isFilterFactoring = true;
    },

    onToggleFilterVoice() {
      this.isFilterFactoring = false;
      this.isFilterVoice = true;
    },

    onToggleFilterBarred() {
      this.isFilterUnbarred = false;
      this.isFilterBarred = !this.isFilterBarred;
    },

    onToggleFilterUnbarred() {
      this.isFilterBarred = false;
      this.isFilterUnbarred = !this.isFilterUnbarred;
    },

    lockSelection() {
      this.lockOrUnlockSelection(true);
      this.isFilterUnbarred = false;
    },

    unlockSelection() {
      this.lockOrUnlockSelection(false);
      this.isFilterBarred = false;
    },

    lockOrUnlockSelection(flag) {
      let changedItemsCnt = 0;
      this.filteredItems.forEach((item) => {
        if (item.items && item.items.length > 0) {
          item.items.forEach((subItem) => {
            subItem.isBarred = flag;
          });
        }
        if (item.isBarred !== flag || item.hasExceptions) changedItemsCnt += 1;
        item.isBarred = flag;
        item.hasExceptions = false;
      });
      if (changedItemsCnt > 0) {
        this.mutableNotice = {
          isBarred: flag,
        };
      }
    },

    onToggle(item) {
      if (item.items && item.items.length > 0) {
        item.items.forEach((subItem) => {
          subItem.isBarred = !item.isBarred;
        });
        item.hasExceptions = false;
      }

      item.isBarred = !item.isBarred;

      this.mutableNotice = {
        type: item.type,
        name: item.name,
        isBarred: item.isBarred,
        hasExceptions: item.hasExceptions,
      };
    },

    onOpenExceptions() {
      this.isNoticeVisible = false;
    },

    onCloseNotice() {
      this.isNoticeVisible = false;
      this.$nextTick(() => {
        document.previousElement.focus();
      });
    },
  },
};
</script>

<style scoped>
.cap-form-fieldset > legend {
  margin: 0;
}

.barring-actions .btn-text {
  float: left;
  padding-bottom: 4px;
}
</style>
